import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ion-margin-vertical ion-text-center" }

import { defineComponent, onMounted, ref, computed, watch, } from 'vue';

// icons
import { add, close } from 'ionicons/icons';

// components
import {
  IonPage,
  IonGrid,
  IonInput, IonTextarea,
  IonIcon,
  IonFooter,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonTitle,
  IonSearchbar,
  IonToolbar,
  IonCol, IonRow, IonLabel, IonCard,
  modalController,
  loadingController
} from '@ionic/vue';
import RoleInClassSelectModal from '@/components/teacher/RoleInClassSelectModal.vue';

// composables
import config from '@/config';
import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';

// services
import TeacherService from '@/services/TeacherService';

// types
import { User } from '@/types';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'RolesInClassesModal',
  props: ["hideHeader", "prefilledRolesInClasses"],
  setup(__props) {

// vue
const props = __props;

// methods
const { t } = useI18n();
const { formatDate, presentToast, presentAlert, presentPrompt, uniqueId } = utils();

// State
const store = useStore();
const user = computed<User>(() => store.state.user);
const activeClassRoles = computed(() => ((user.value.teacher?.classRoles || []).filter(cr => cr.status != 'removed')));
const searchKeyword = ref(""); // TBC: for searching class / subjects?
const rolesInClasses = ref([{
  id: `ric${uniqueId()}`,
  role: "",
  classes: "",
  remarks: "",
}]);

// Prefill selected roles / user class roles
onMounted(() => {
  const { prefilledRolesInClasses } = props;
  if (prefilledRolesInClasses && prefilledRolesInClasses.length > 0) {
    rolesInClasses.value = prefilledRolesInClasses;
  } else {
    rolesInClasses.value = [...(activeClassRoles.value as any)];
  }
})
watch(user, () => {
  if (!props.prefilledRolesInClasses) {
    rolesInClasses.value = [...(activeClassRoles.value as any)];
  }
})

// Methods
const cancelChanges = async () => (await modalController.dismiss({}));
const confirmChanges = async () => {
  if (props.hideHeader) { // from TeacherRolesModal
    const loading = await loadingController.create({});
    await loading.present();

    // Check remove class roles (set status to removed)
    const removedClassRoles: any = activeClassRoles.value.filter(acr => (rolesInClasses.value.find(cr => cr.id == acr.id) == null));
    const updatedClassRoles = rolesInClasses.value.concat(removedClassRoles.map(rcr => {
      rcr.status = 'removed';
      return rcr;
    }));
    TeacherService.updateTeacher(user.value, { classRoles: updatedClassRoles });
    store.commit('upsertTeacherClassRoles', updatedClassRoles);
    presentToast("Saved successfully!");

    loading.dismiss();
  }
  else {
    await modalController.dismiss({ rolesInClasses: rolesInClasses.value })
  }
};

const incrementRoleInClass = () => {
  rolesInClasses.value.push({
    id: `ric${uniqueId()}`,
    role: "",
    classes: "",
    remarks: "",
  })
};
const removeRoleInClass = (idx) => {
  rolesInClasses.value.splice(idx, 1);
};

// Modal
const openRoleInClassSelectModal = async (idx, prefilledRole, classes, initialSection = 1) => {
  const modal = await modalController.create({
    component: RoleInClassSelectModal,
    componentProps: { initialSection, prefilledRole, prefilledClasses: classes ? classes.split(" , ") : [] },
  });
  modal.onDidDismiss().then(({ data }) => {
    if (data && data.selectedRole) {
      const targetObj = rolesInClasses.value[idx];
      targetObj.role = data.selectedRole;
      targetObj.classes = data.selectedClasses.sort().join(" , ");
      if (prefilledRole != data.selectedRole) targetObj.id = `ric${uniqueId()}`; // role change: gen new row to keep records
    }
  });
  return modal.present();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { fixed: "" }, {
            default: _withCtx(() => [
              (!__props.hideHeader)
                ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTitle), null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Your role(s) in class(es), if applicable.")
                        ])),
                        _: 1,
                        __: [3]
                      }),
                      _createVNode(_unref(IonButtons), { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            slot: "icon-only",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelChanges()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { fixed: "" }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (confirmChanges()), ["prevent"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesInClasses.value, (rc, i) => {
                  return (_openBlock(), _createBlock(_unref(IonCard), {
                    style: {"border-left":"8px solid #EF6C00"},
                    key: i
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, "Role " + _toDisplayString(i+1), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonButtons), { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                onClick: ($event: any) => (removeRoleInClass(i))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    icon: _unref(close)
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { size: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonTextarea), {
                                fill: "outline",
                                label: "You are a",
                                labelPlacement: "floating",
                                type: "text",
                                modelValue: rc.role,
                                "onUpdate:modelValue": ($event: any) => ((rc.role) = $event),
                                onClick: ($event: any) => (openRoleInClassSelectModal(i, rc.role, rc.classes)),
                                required: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonCol), { size: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonTextarea), {
                                fill: "outline",
                                label: "in class(es)",
                                labelPlacement: "floating",
                                type: "text",
                                modelValue: rc.classes,
                                "onUpdate:modelValue": ($event: any) => ((rc.classes) = $event),
                                onClick: ($event: any) => (openRoleInClassSelectModal(i, rc.role, rc.classes, rc.role ? 2 : 1)),
                                required: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(IonButton), {
                    color: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (incrementRoleInClass())),
                    shape: "round"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(add)
                      }, null, 8, ["icon"]),
                      _cache[4] || (_cache[4] = _createTextVNode(" Add More "))
                    ]),
                    _: 1,
                    __: [4]
                  })
                ]),
                _createVNode(_unref(IonButton), {
                  class: "ion-margin-vertical",
                  type: "submit",
                  expand: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('UserProfilePage.save')), 1)
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})